<template>
  <div class="entity-details-layout entity-details-layout-list">
    <icon-in-circle class="entity-details-icon">
      <font-awesome-icon :icon="['far', 'building']"/>
    </icon-in-circle>
    <div class="entity-details-header pv4 ph3 ph1-l">
      <span class="fw6 lh-copy">
        {{ claim.name }}
      </span>
      <div class="mt3 flex">
        <font-awesome-icon :icon="['far', 'building']" class="w2 mr2 entity-icon"/>
        <span>{{ claim.departmentName }}</span>
      </div>
      <div class="mt2 flex">
        <font-awesome-icon :icon="['fa', 'user']" class="w2 mr2 entity-icon"/>
        <span>{{ claim.userName }}</span>
      </div>
    </div>
    <div v-if="showDetails" class="entity-details-content ml3 ml4-l bt b--near-white bw1 mb4">
      <div v-if="claim.finishedDate" class="flex flex-column mt4">
        <span>{{ deliveryDate() }}</span>
        <span class="mt1 entity-secondary ttl">Дата поставки</span>
      </div>

      <div v-if="claim.limit" class="flex flex-column mt4">
        <span>{{ claim.limit }}</span>
        <span class="mt1 entity-secondary ttl">Лимит</span>
      </div>

      <div v-if="claim.billDirection" class="flex flex-column mt4">
        <span>{{ claim.billDirection }}</span>
        <span class="mt1 entity-secondary ttl">Статья расходов</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconInCircle from '@/components/ui/IconInCircle.vue'
import { momentFromString } from '@/utils/datetime.js'

export default {
  components: {
    IconInCircle
  },
  props: ['claim'],
  computed: {
    showDetails () {
      return this.claim.finishedDate || this.claim.limit || this.claim.billDirection
    }
  },
  methods: {
    deliveryDate () {
      return this.claim.finishedDate
        ? this.format(this.claim.finishedDate)
        : null
    },
    format (dt) {
      return momentFromString(dt)?.format('LL')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
